import React, { PropsWithChildren } from "react";
import { LottiePlayer } from "../../../lottie-player/LottiePlayer";
import ampTimeAnimation from "./assets/amp-time.lottie";
import ftAnimation0 from "./assets/focus-time-0.svg";
import ftAnimation1 from "./assets/focus-time-1.svg";
import ftAnimation2 from "./assets/focus-time-2.svg";
import ftAnimation4 from "./assets/focus-time-4.svg";
interface Props {
  title?: JSX.Element | string;
}
export const Slide = ({ title, children }: PropsWithChildren<Props>) => {
  return (
    <div className="cw-flex-col cw-flex cw-w-full cw-px-2 md:cw-px-0 cw-h-full">
      {title && (
        <div className="cw-flex cw-justify-center cw-items-center cw-w-full cw-h-16">
          <div className="cw-heading-2xl md:cw-heading-3xl cw-text-center">{title}</div>
        </div>
      )}
      <div className="cw-flex cw-justify-center cw-w-full cw-h-full md:cw-max-h-[475px] ">
        {children}
      </div>
    </div>
  );
};

export const AnimatedSlides = [
  <Slide key="slide-0" title={<div>The more flexible you can be, the more we can help</div>}>
    <img src={ftAnimation0} className="cw-w-full md:cw-h-[475px]" />{" "}
  </Slide>,
  <Slide key="slide-1" title={<div>Once a day, Clockwise analyzes your team's calendars</div>}>
    <img src={ftAnimation1} className="cw-w-full md:cw-h-[475px]" />
  </Slide>,
  <Slide
    key="slide-2"
    title={<div>And moves your flexible meetings to the best time for everyone</div>}
  >
    <img src={ftAnimation2} className="cw-w-full md:cw-h-[475px]" />
  </Slide>,
  <Slide
    key="slide-3"
    title={<div>So that all of you will have more time to focus on what matters</div>}
  >
    <LottiePlayer
      className="cw-mt-6 md:cw-mt-0 cw-w-full md:cw-h-[475px]"
      autoplay
      loop
      src={ampTimeAnimation}
    />
  </Slide>,
  <Slide key="slide-4" title={<div>All possible wherever you work</div>}>
    <img src={ftAnimation4} className="cw-w-full md:cw-h-[475px]" />
  </Slide>,
];
